import { render } from "./deactivecustomerheader.vue?vue&type=template&id=27b20d2e"
import script from "./deactivecustomerheader.vue?vue&type=script&lang=js"
export * from "./deactivecustomerheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__